import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Link } from '@tyro/router/components';
import { IconPickerIcon } from '../icon-picker/icon';
import type { DataCollectionGroup } from './types';

interface DataCollectionGroupCardProps {
  group: DataCollectionGroup;
  getGroupLink: (group: DataCollectionGroup) => string;
}

export function DataCollectionGroupCard({
  group,
  getGroupLink,
}: DataCollectionGroupCardProps) {
  return (
    <Grid size={{ xs: 12, sm: 6, md: 4 }}>
      <Card>
        <CardActionArea component={Link} to={getGroupLink(group)}>
          <Stack direction="row" alignItems="center" spacing={2}>
            <IconPickerIcon icon={group.icon} />
            <Stack>
              <Typography variant="subtitle2" component="h3">
                {group.title}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {group.description}
              </Typography>
            </Stack>
          </Stack>
        </CardActionArea>
      </Card>
    </Grid>
  );
}
